import React from 'react';
import GeneralErrorIcon from '@public/images/general-error-grey.svg';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

type Props = {
    msg?: string;
    onCancel?: () => void;
    onRetry?: () => void;
    cancleText?: string;
    retryText?: string;
};

export default function ErrorMsg({ msg, onCancel, onRetry, cancleText, retryText }: Props) {
    const { t } = useTranslation();
    return (
        <div className='flex flex-col w-[275px] items-center'>
            <div className='pt-1'>
                <GeneralErrorIcon></GeneralErrorIcon>
            </div>
            <span className='pt-4 pb-8 px-2 whitespace-pre-line text-center font-medium'>
                {msg ?? t('errorMsg.notAvailableMsg')}
            </span>
            <div className='flex'>
                {onCancel && (
                    <button
                        className='bg-[#E1EBF5] text-[#002E5A] w-[118px] h-[40px] rounded font-me mr-2'
                        onClick={onCancel}
                    >
                        {cancleText ?? t('errorMsg.cancel')}
                    </button>
                )}
                <button
                    className={classNames(
                        'bg-[#002E5A] text-white w-[118px] h-[40px] rounded font-medium',
                        { 'w-[158px]': !onCancel }
                    )}
                    onClick={onRetry}
                >
                    {retryText ?? t('errorMsg.tryAgain')}
                </button>
            </div>
        </div>
    );
}
